window.auditSSOLogin = function() {

    // get token
    $.ajax({
        type: 'POST',
        url: '/admin/audit/sso/token',
        success: function (data) {
            // redirect
            window.open(
                process.env.MIX_AUDIT_SSO_URL + '?access_token=' + data.token,
                '_blank'
            );
        }, error: function (err) {
            console.log(err);
        }
    });

}